import { createReducer, on } from '@ngrx/store';
import { IEntidad } from '@shared/interfaces/app.state.interfaces';
import { setEntidades } from '../actions/entidades.actions';

export const initialState: { [tipo: string]: IEntidad[] } = {};

export const entidadesReducer = createReducer(
    initialState,
    on(setEntidades, (state, { tipo, data }) => ({
        ...state,
        [tipo]: data
    }))
);
